const RuralDevelopmentdata = [
    {
        id : "1",
        schemeName: "Mahatma Gandhi National Rural Employement  Gurantee  Act (MGNREGA)",
        discription:"The Mahatma Gandhi National Rural Employment Guarantee Act (MGNREGA) is an Indian labour law and social security measure that aims to guarantee the 'right to work'1. It was passed in September 2005 under the UPA government of Prime Minister Dr. Manmohan Singh",
        launchDate: "September 2005",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "National Rural Livelihoods Mission (NRLM) ",
    discription:"National Rural Livelihood Mission (NRLM) was launched as ‘Aajeevika – National Rural Livelihoods Mission (NRLM)’ by the GOI’s Ministry of Rural Development in the year 2011. It was renamed as DAY-NRLM in 20151. The scheme is an improved version of the earlier Swarnjayanti Gram Swarozgar Yojana (SGSY).",
    launchDate: " year 2011",
    AnualFund: "12345"},
   

    {id : "3",
    schemeName: "Housing for All : Pradhan Mantri Awaas Yojana - Grameen (PMAY-G)",
    discription:"In order to achieve the target of “Housing for All” in rural areas, the Ministry of Rural Development is implementing Pradhan Mantri Awaas Yojana- Gramin (PMAY-G) with effect from 1st April, 2016 to provide assistance to eligible rural households with overall target to construct 2.95 crore pucca houses with basic amenities by March, 2024.",
    launchDate: "1 April 2016",
    AnualFund: "12345"},
   
    {
    id : "4",
        schemeName: "National Social Assistance Programme (NSAP)",
        discription:"The National Social Assistance Programme (NSAP) is a Centrally Sponsored Scheme of the Government of India that provides financial assistance to the elderly, widows and persons with disabilities in the form of social pensions. The NSAP scheme only includes Below Poverty Line individuals as beneficiaries.",
        launchDate: "15 August 1995",
        AnualFund: "12345"
    },
   { id : "5",
    schemeName: "Shyama Prasad Mukherjee RURBAN Mission",
    discription:"Government approved the Shyama Prasad Mukherji Rurban Mission (SPMRM) with an outlay of   Rs.      5142.08 crores on 16 September 2015. Rurban Mission was launched by the Hon'ble Prime   Minister on 21 February, 2016at Kurubhata, Murmunda Rurban Cluster, Rajnandgaon, Chattisgarh. ",
    launchDate: "16 September 2015", 
     AnualFund: "12345"},
   

 {   id : "6",
    schemeName: "Integrated Watershed Management Programme (IWMP)",
    discription:"This consolidation is for optimum use of resources, sustainable outcomes and integrated planning. The scheme was launched during 2009-10.",
    launchDate: "Year 2009-10",
    AnualFund: "12345"
},
{   id : "7",
schemeName: "Pradhan Mantri Gram Sadak Yojana (PMGSY) ",
discription:"The Government of India launched the Pradhan Mantri Gram Sadak Yojana (referred to as PMGSY-I hereinafter) on 25th December 2000 to provide all-weather access to eligible unconnected habitations with a population of up to 500(Census 2001) in plain area and 250 and above in Special category States(States of North East, Jammu, and Kashmir, Himachal Pradesh, Uttarakhand), Desert Area as identified by Desert Development Program and 88 selected Backward Districts as identified by the Ministry of Home Affairs/Planning Commission as a strategy for poverty alleviation.",
launchDate: "1 August 2018",
AnualFund: "12345"},






]

export default RuralDevelopmentdata;
